export const BASE_TELESTRATION_STAGE_SIZE = { width: 800, height: 450 };
